<mat-dialog-content>
  <h3>{{ 'Docker Hub Rate Limit Warning' | translate }}</h3>
  <div>
    <p>{{ warningText }}</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-button
    type="button"
    ixTest="close"
    [matDialogClose]="true"
  >
    {{ 'Close' | translate }}
  </button>
</mat-dialog-actions>
